var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDriver = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2e374d",
    d: "M12 2a3.9 3.9 0 0 0-4 3.8 3.9 3.9 0 0 0 4 3.8 3.9 3.9 0 0 0 4-3.8A3.9 3.9 0 0 0 12 2zm0 9.5c-4.347 0-9 1.985-9 4.939v2.082a.482.482 0 0 0 .379.462l2.8.662A5.419 5.419 0 0 0 6 21h12a5.419 5.419 0 0 0-.178-1.354l2.8-.662a.482.482 0 0 0 .378-.463v-2.082c0-2.954-4.653-4.939-9-4.939zm0 1.9c3.77 0 7 1.671 7 3.039v.969l-1.984.473a6.164 6.164 0 0 0-10.031 0L5 17.408v-.969c0-1.368 3.23-3.039 7-3.039z",
    transform: "translate(-3 -2)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDriver, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/driver.a53e36d2.svg";
export { ForwardRef as ReactComponent };